"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalType = void 0;
/**
 * Proposal types represents what is being buyed.
 */
var ProposalType;
(function (ProposalType) {
    ProposalType["Pension"] = "pension";
    // LifeInsurance = 'life_insurance',
})(ProposalType = exports.ProposalType || (exports.ProposalType = {}));
//# sourceMappingURL=ProposalType.js.map